import { handleActions } from "redux-actions";

export const coursesReducer = handleActions(
  {
    UPDATED_COURSE: (state, action) => {
      return {
        ...state,
        courses: [
          ...state.courses.filter(
            (element) => element._id !== action.payload._id
          ),
          action.payload,
        ],
      }
    },
    GET_COURSES: (state, action) => {
      return {
        ...state,
        fetching: true,
      };
    },
    GET_COURSES_FINISHED: (state, action) => {
      return {
        ...state,
        fetching: false,
        courses: action.payload,
      };
    },
    GET_COURSES_ERROR: (state, action) => {
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    },
    CREATE_COURSE: (state, action) => {
      return {
        ...state,
        fetching: true,
      };
    },
    CREATE_COURSE_FINISHED: (state, action) => {
      return {
        ...state,
        fetching: false,
        courses: [...state.courses, action.payload.course],
      };
    },
    CREATE_COURSE_ERROR: (state, action) => {
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    },
    DELETE_COURSE: (state, action) => {
      return {
        ...state,
        fetching: true,
      };
    },
    DELETE_COURSE_FINISHED: (state, action) => {
      return {
        ...state,
        fetching: false,
        courses: [
          ...state.courses.filter(
            (course) => course._id !== action.payload.course._id
          ),
        ],
      };
    },
    DELETE_COURSE_ERROR: (state, action) => {
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    },
    EDIT_COURSE: (state, action) => {
      return {
        ...state,
        fetching: true,
      };
    },
    EDIT_COURSE_FINISHED: (state, action) => {
      return {
        ...state,
        courses: [
          ...state.courses.filter(
            (element) => element._id !== action.payload.course._id
          ),
          action.payload.course,
        ],
      };
    },
  },
  {
    fetching: false,
    courses: [],
    error: null,
  }
);

export const getCourses = (state) => state.courseState.courses;
export const getCoursesFetching = (state) => state.courseState.fetching;
export const getCoursesError = (state) => state.courseState.error;
